<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>SOBRE AS INDÚSTRIAS E OS CENTROS LOGÍSTICOS</h1>
      <p>
      Hoje, a Restoque conta com duas plantas industriais: uma em Terra Boa (Paraná) e a outra em Aparecida de Goiânia (GO). No Paraná, temos mais de 650 colaboradores e a Restoque é a segunda maior empregadora do município, trazendo colaboradores de cinco cidades vizinhas. Já em Goiás, a fábrica inaugurada em 2017, iniciou com 27 colaboradores e atualmente conta com 200 Restoquers divididos entre Indústria e Centro Logístico.
Nosso segundo Centro Logístico fica em São Paulo, anexo ao nosso escritório e conta com quase 200 colaboradores.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>